export function isValidObjectWithRequiredKeys<T extends Record<string, unknown>> (
    value: unknown,
    requiredKeys: (keyof T)[],
): value is T {
    return (
        typeof value === 'object'
      && value !== null
      && requiredKeys.every(key => key in value)
    );
}
